export const API = {
  PORT:
    process.env.NODE_ENV == "development" ? "https://api.sortyfy.com/api" : "",
};

export const BASEURL = {
  PORT:
    process.env.NODE_ENV == "development" ? "https://api.sortyfy.com/api" : "",
  // process.env.NODE_ENV == "development" ? "http://sortyfy.com:4000/api" : "",
};

export const MAX_WORDS = 500;
export const MIN_WORDS = 50;

export const MAP_KEY = "AIzaSyA90T5hER9e1HRefw97yHFy2l-rfo1r13Q";
export const maxSize = 3 * 1024 * 1024;

export const daysData = [
  {
    day: "Monday",
    fromTime: "10:00",
    toTime: "23:00",
    fullDay: false,
  },
  {
    day: "Tuesday",
    fromTime: "10:00",
    toTime: "23:00",

    fullDay: false,
  },
  {
    day: "Wednesday",
    fromTime: "10:00",
    toTime: "23:00",

    fullDay: false,
  },
  {
    day: "Thursday",
    fromTime: "10:00",
    toTime: "23:00",

    fullDay: false,
  },
  {
    day: "Friday",
    fromTime: "10:00",
    toTime: "23:00",

    fullDay: false,
  },
  {
    day: "Saturday",
    fromTime: "10:00",
    toTime: "23:00",

    fullDay: false,
  },
  {
    day: "Sunday",
    fromTime: "10:00",
    toTime: "23:00",

    fullDay: false,
  },
];

export const upperCase = (str) => {
  return str?.charAt(0).toUpperCase() + str?.slice(1);
};
